/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Sweet_OverloadInputs */

const en_coach_sweet_overload = /** @type {(inputs: Coach_Sweet_OverloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are carrying significant fatigue from recent training. Your body needs rest to absorb the training stress and come back stronger. Take easy days or a full rest day before pushing hard again.`)
};

const de_coach_sweet_overload = /** @type {(inputs: Coach_Sweet_OverloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du trägst ordentlich Ermüdung vom letzten Training. Dein Körper braucht Ruhe, um den Stress zu verarbeiten und stärker zurückzukommen. Mach lockere Tage oder einen Ruhetag, bevor du wieder Gas gibst.`)
};

/**
* | output |
* | --- |
* | "You are carrying significant fatigue from recent training. Your body needs rest to absorb the training stress and come back stronger. Take easy days or a ful..." |
*
* @param {Coach_Sweet_OverloadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_sweet_overload = /** @type {((inputs?: Coach_Sweet_OverloadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Sweet_OverloadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_sweet_overload(inputs)
	return de_coach_sweet_overload(inputs)
});